export default function initBatchwiseTimetableCascading() {
  const data = window.sasBttData;
  if (!data) return;

  const form = document.querySelector("[data-sas-btt-cascading]");
  const semSel = document.getElementById("btt-semester");
  const progSel = document.getElementById("btt-program");
  const batchSel = document.getElementById("btt-batch");
  if (!semSel || !progSel || !batchSel) return;

  function refreshChoices(selectEl) {
    selectEl.dispatchEvent(
      new CustomEvent("sas:searchable-select-refresh", { bubbles: true })
    );
  }

  function resetSelect(selectEl, placeholderText) {
    selectEl.innerHTML = "";
    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent = placeholderText;
    selectEl.appendChild(ph);
    selectEl.value = "";
    selectEl.disabled = true;
    refreshChoices(selectEl);
  }

  function populatePrograms(semId) {
    resetSelect(batchSel, "Choose program first\u2026");

    if (!semId) {
      resetSelect(progSel, "Choose semester first\u2026");
      return;
    }
    if (!data.programs || !data.programs[semId]) {
      resetSelect(progSel, "No programs for this semester");
      return;
    }

    progSel.innerHTML = "";
    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent =
      progSel.getAttribute("data-sas-select-placeholder") || "Choose\u2026";
    progSel.appendChild(ph);

    data.programs[semId].forEach(function (item) {
      var opt = document.createElement("option");
      opt.value = item.id;
      opt.textContent = item.name;
      progSel.appendChild(opt);
    });

    progSel.disabled = false;
    refreshChoices(progSel);
  }

  function populateBatches(semId, progId) {
    var key = semId + "-" + progId;

    if (!progId || !semId) {
      resetSelect(batchSel, "Choose program first\u2026");
      return;
    }
    if (!data.batches || !data.batches[key]) {
      resetSelect(batchSel, "No batches available");
      return;
    }

    batchSel.innerHTML = "";

    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent =
      batchSel.getAttribute("data-sas-select-placeholder") || "Choose\u2026";
    batchSel.appendChild(ph);

    var allOpt = document.createElement("option");
    allOpt.value = "all";
    allOpt.textContent = "ALL batches (consolidated grid)";
    batchSel.appendChild(allOpt);

    data.batches[key].forEach(function (b) {
      var opt = document.createElement("option");
      opt.value = b.id;
      opt.textContent = b.display;
      batchSel.appendChild(opt);
    });

    batchSel.disabled = false;
    refreshChoices(batchSel);
  }

  semSel.addEventListener("change", function () {
    populatePrograms(semSel.value);
  });

  progSel.addEventListener("change", function () {
    populateBatches(semSel.value, progSel.value);
  });
}
